import { useQuery } from '@tanstack/react-query';

import { useAuth } from 'context/AuthContext';
import { getPaymentStatisticsRequest } from '@/api';

function useGetPaymentsStatistics() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: ['paymentStatistics'],
    queryFn: () => getPaymentStatisticsRequest(),
    enabled: isAuthenticated,
    select: (data) => data.data, // Вибираємо тільки дані з відповіді
  });
}

export default useGetPaymentsStatistics;
